/**
 * Creates a generator that yields random array indices without repeating
 * until all indices have been used, then automatically resets and starts over.
 *
 * Each generator instance maintains its own isolated state, making it safe
 * for concurrent use from different modules.
 *
 * @param arrayLength The total length of the array to select indices from.
 * @returns A generator that yields random indices in the range [0, arrayLength).
 */
export function* createShuffledRandomSelector(arrayLength: number): Generator<number, never, void> {
	let availableIndices = Array.from({ length: arrayLength }, (_, i) => i);

	while (true) {
		if (availableIndices.length === 0) {
			availableIndices = Array.from({ length: arrayLength }, (_, i) => i);
		}

		const randomIndex = Math.floor(Math.random() * availableIndices.length);
		const selectedIndex = availableIndices[randomIndex];

		availableIndices.splice(randomIndex, 1);

		yield selectedIndex;
	}
}
